import CreateSuccess from './CreateSuccess';

export default CreateSuccess;
